'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _query = require('./query');

var _filterFilterBuilder = require('./filter/filterBuilder');

var _filterFilterBuilder2 = _interopRequireDefault(_filterFilterBuilder);

var _sortSortBuilder = require('./sort/sortBuilder');

var _sortSortBuilder2 = _interopRequireDefault(_sortSortBuilder);

var _postprocessingRefTransformer = require('./postprocessing/ref-transformer');

var _postprocessingRefDeduplicator = require('./postprocessing/ref-deduplicator');

var _wixDataWebmethodStructures = require('wix-data-webmethod-structures');

var _sharedValidations = require('./shared/validations');

var _errors = require('./errors');

var _sharedTypeUtils = require('./shared/type-utils');

var _multiref = require('./multiref');

/**
 * The built-in String object.
 * @external String
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String|MDN String}
 */

/**
 * The built-in Array object.
 * @external Array
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array|MDN Array}
 */

/**
 * The built-in Function object.
 * @external Function
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function|MDN Function}
 */

/**
 * The Promise object is used for deferred and asynchronous computations.
 * @description A Promise represents a value that is not necessarily known when the promise is created because it depends on asynchronous communication. To learn more, see <a href="https://support.wix.com/en/article/working-with-promises-in-wix-code">Working with Promises in Wix Code</a>.
 *
 * @external Promise
 * @see {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Promise|MDN Promise}
 */

/**
 * The built-in Boolean object.
 * @external Boolean
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean|MDN Boolean}
 */

/**
 * The built-in Object object.
 * @external Object
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object|MDN Object}
 */

/**
 * The built-in Number object.
 * @external Number
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number|MDN Number}
 */

/**
 * The built-in Date object.
 * @external Date
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date|MDN Date}
 */

/**
 * The built-in Error object.
 * @external Error
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error|MDN Error}
 */

/**
 * The Node.js Buffer object.
 * @external Buffer
 * @see {@link https://nodejs.org/api/buffer.html|Node.js Buffer}
 */

/**
 * @typedef wix-data~WixDataOptions
 * @summary An object that you pass as the `options` parameter that modifies how an operation is performed.
 * @property {external:Boolean} suppressAuth Prevents <a href="https://www.wix.com/support/html5/article/how-do-i-work-with-wix-data-permissions" target="_blank">permission</a> checks from running for the operation.
 * @property {external:Boolean} suppressHooks Prevents <a href="https://www.wix.com/support/html5/article/how-do-i-work-with-hooks" target="_blank">hooks</a> from running for the operation.
 * @memberof wix-data
 * @description
 *  The `options` parameter is an optional parameter that can be used when
 *  calling some wix-data functions. To use `options`, pass it a `WixDataOptions`
 *  object with one or both of the following key:value pairs:
 *
 *  + `"suppressAuth"`: `true`/`false`
 *  + `"suppressHooks"`: `true`/`false`
 *
 *
 *  The `options` parameter can only be used in backend code. Permission checks
 *  and hooks always run for wix-data functions called from Page, Site and
 *  Public code.
 * @snippet [WixDataOptions.es6=Create a data options object]
 * @snippet [WixDataOptions_get.es6=Use data options to prevent permission checks and hooks from running]
 */

// ======================================================================================================================

/**
 * @namespace wix-data
 *
 * @summary The wix-data module contains functionality for working with data in collections.
 * @description
 *  To use the data module, import `wixData` from the `wix-data` module:
 *
 *    ``` javascript
 *    import wixData from 'wix-data';
 *    ```
 *
 *  The wix-data API can be used in your site’s front-end or backend code.
 *
 *  The wix-data API includes fuctions for managing the data in your collections,
 *  building queries on collections, and registering hooks.
 *
 *  For more information, see <a href="https://www.wix.com/support/html5/article/working-with-the-data-api" target="_blank">Working with the Data API</a>.
 *
 *  <h3 id="data-types">Data Types</h3>
 *
 *  The following is a list of the field types from database collections and their
 *  corresponding JavaScript data types. When you retrieve data from a collection,
 *  that data will be represented in the JavaScript data types that correspond
 *  to your collection's field types. When you add or update data in a collection,
 *  you provide the data using the JavaScript data types that correspond to your
 *  collection's field types.
 *
 *  <table style="border-collapse: collapse;">
 *    <tr>
 *      <td><b>Field Type</b></td>
 *      <td><b>Data Type</b></td>
 *      <td><b>Notes</b></td>
 *    </tr>
 *    <tr>
 *      <td>Text</td>
 *      <td>JavaScript string</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Image</td>
 *      <td>JavaScript string</td>
 *      <td>An image URL as described <a href="/$w.Image.html#src">here</a>.</td>
 *    </tr>
 *    <tr>
 *      <td>Boolean</td>
 *      <td>JavaScript boolean</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Number</td>
 *      <td>JavaScript number</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Date and Time</td>
 *      <td>JavaScript Date object</td>
 *      <td></td>
 *    </tr>
 *    <tr>
 *      <td>Rich Text</td>
 *      <td>JavaScript string</td>
 *      <td>A string which can contain a [subset of HTML tags]($w.Text.html#formatting-text).</td>
 *    </tr>
 *    <tr>
 *      <td>URL</td>
 *      <td>JavaScript string</td>
 *      <td>A valid URL.</td>
 *    </tr>
 *    <tr>
 *      <td>Document</td>
 *      <td>JavaScript string</td>
 *      <td>A Media Manager document URL as described <a href="/$w.LinkableMixin.html#link">here</a>.</td>
 *    </tr>
 *    <tr>
 *      <td>Reference</td>
 *      <td>JavaScript string</td>
 *      <td>An item ID from the referenced collection.</td>
 *    </tr>
 *  </table>
 *
 */

var WixDataApi = (function () {
  function WixDataApi(provider) {
    _classCallCheck(this, WixDataApi);

    this.provider = provider;
  }

  /**
   * @function get
   * @syntax
   * function get(collectionName: String, itemId: String,
   *   [options:WixDataOptions]): Promise&lt;Object&gt;
   * @summary Retrieves an item from a collection.
   * @description
   *  The `get()` function returns a Promise that resolves to the item with ID
   *  `itemId` from collection `collectionName`. The Promise is rejected if the
   *  current user does not have read permissions for the collection.
   *
   *  Calling the `get()` function triggers the [`beforeGet()`](wix-data.Hooks.html#beforeGet)
   *  and [`afterGet()`](wix-data.Hooks.html#afterGet) hooks if they have been defined.
   *
   *  Use the `options` parameter to run `get()` without checking for permissions
   *  or without its registered hooks.
   * @snippet [WixData-get.es6=Get an item from a collection]
   * @snippet [WixData-get_options.es6=Get an item from a collection using data options]
   * @param {external:String} collectionName - The name of the collection to retrieve the item from.
   * @param {external:String} itemId - The ID of the item to retrieve.
   * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
   * @returns {external:Promise}
   * @fulfill {external:Object} The retrieved item.
   * @reject {external:Error} The error that caused the rejection.
   * @memberof wix-data
   * @instance
   */

  _createClass(WixDataApi, [{
    key: 'get',
    value: function get(collectionName, itemId, options) {
      var _this = this;

      return (0, _sharedValidations.apiValidator)().arity('get', arguments, 2, 3).collectionName(collectionName).itemId(itemId).options(options).validateAndReject().then(function () {
        return _this.provider.get(collectionName, itemId, options);
      }).then(passOrWrap);
    }

    /**
     * @function insert
     * @syntax
     * function insert(collectionName: String, item: Object,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Adds an item to a collection.
     * @description
     *  The `insert()` function returns a Promise that resolves to the inserted item
     *  after the specified item has been added to the collection `collectionName`. The
     *  Promise is rejected with an error if:
     *
     *  + The specified collection does not exist.
     *  + The specified item is not of type `Object`.
     *  + The specified item includes an `_id` property whose value matches an existing ID in the collection. Meaning, `insert()` cannot overwrite an existing item in the collection.
     *  + The current user does not have create permissions for the collection.
     *
     *
     *  Calling the `insert()` function triggers the [`beforeInsert()`](wix-data.Hooks.html#beforeInsert)
     *  and [`afterInsert()`](wix-data.Hooks.html#afterInsert) hooks if they have been defined.
     *
     *  Use the `options` parameter to run `insert()` without checking for permissions
     *  or without its registered hooks.
     *
     *  When inserting an item into a collection that has a reference field, set
     *  the value of the reference field to the referenced item's `_id` value or
     *  the entire referenced item object.
     *
     *  The `insert()` function adds the following properties and values to the item
     *  when it adds it to the collection:
     *
     *  + `_id`: A unique identifier for the item with collection, if the item does not include one. You can optionally provide your own ID. Once an ID is assigned to an item it cannot be changed.
     *  + `_createdDate`: The date the item was added to the collection.
     *  + `_updatedDate`:  The date the item was modified. When the item is first added, the `createdDate` and `updatedDate` are the same.
     *
     *
     *  Any valid JavaScript object can be added as a property value. The `insert()`
     *  function maintains the structure of the specified object. For example,
     *  objects that contain nested objects, Arrays, or Arrays with nested objects
     *  are all added to the collection as defined.
     *
     * The maximum size of an item that you can add to a collection is 200kb.
     * @snippet [WixData-insert.es6=Insert an item into a collection]
     * @snippet [WixData-insert_id.es6=Insert an item with a specified ID into a collection]
     * @snippet [WixData-insert_options.es6=Insert an item into a collection using data options]
     * @snippet [WixData-insert_ref_id.es6=Insert an item including a reference to another item]
     * @snippet [WixData-insert_ref_item.es6=Insert an item including a reference to another item]
     * @param {external:String} collectionName - The name of the collection to add the item to.
     * @param {external:Object} item - The item to add.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The item that was added.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'insert',
    value: function insert(collectionName, item, options) {
      var _this2 = this;

      return (0, _sharedValidations.apiValidator)().arity('insert', arguments, 2, 3).validateAndReject().then(function () {
        return mutate(_this2.provider, 'insert')(collectionName, item, options);
      });
    }

    /**
     * @function query
     * @syntax
     * function query(collectionName: String): WixDataQuery
     * @summary Creates a query.
     * @description
     *  The `query()` function builds a query on the specified collection and returns
     *  a {@link wix-data.WixDataQuery|WixDataQuery} object.
     *
     *  The returned object contains the query definition which is typically used
     *  to run the query using the [`find()`](wix-data.WixDataQuery.html#find)
     *  function.
     *
     *  You can refine the query by chaining {@link wix-data.WixDataQuery|WixDataQuery}
     *  functions on to the query. `WixDataQuery` functions enable you to sort,
     *  filter, and control the number of results a query returns.
     *
     *  The `query()` runs with the following {@link wix-data.WixDataQuery|WixDataQuery}
     *  defaults that you can override:
     *
     *  + [**skip**](wix-data.WixDataQuery.html#skip) - `0`
     *  + [**limit**](wix-data.WixDataQuery.html#limit) - `50`
     *  + [**descending**](wix-data.WixDataQuery.html#descending) - by `_createdDate`
     *  + [**include**](wix-data.WixDataQuery.html#skip) - none
     *
     *
     *
     *  The functions that are chained to `query()` are applied in the order they
     *  are called. For example, if you sort on an `age` property in ascending
     *  order and then on a `name` property in descending order, the results are
     *  sorted first by the age of the items and then, if there are multiple
     *  results with the same age, the items are sorted by name in descending
     *  order, per age value.
     * @snippet [WixData-query.es6=Build a query]
     * @snippet [WixData-query_find.es6=Build and perform a query]
     * @snippet [WixData-query_chain.es6=Build and perform a query using data options]
     * @snippet [WixData-query_build.es6=Build a query incrementally]
     *  This example builds a query based on certain conditions. It then performs the
     *  query and uses the results to populate a table.
     * @param {external:String} collectionName - The collection you want to run the query on.
     * @returns {wix-data.WixDataQuery} A query object.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'query',
    value: function query(collectionName) {
      return (0, _query.queryFactory)(this.provider, collectionName);
    }
  }, {
    key: 'ref',
    value: function ref(obj) {
      if (reflessJoinsEnabled()) {
        return obj;
      } else {
        return new _wixDataWebmethodStructures.Ref(obj);
      }
    }

    /**
     * @function filter
     * @syntax
     * function filter(): WixDataFilter
     * @summary Creates a filter to be used with the dataset `setFilter()` function.
     * @description
     *  This function is not used on its own. It is only used to create a filter
     *  for a dataset using the [`setFilter()`](wix-dataset.html#setFilter) function.
     * @snippet [WixData-filter.es6=Filter a dataset]
     * @returns {wix-data.WixDataFilter} A filter object.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'filter',
    value: function filter() {
      return (0, _filterFilterBuilder2['default'])();
    }

    /**
     * @function sort
     * @syntax
     * function sort(): WixDataSort
     * @summary Creates a sort to be used with the dataset `setSort()` function.
     * @description
     *  This function is not used on its own. It is only used to create a sort
     *  for a dataset using the [`setSort()`](wix-dataset.html#setSort) function.
     * @snippet [WixData-sort.es6=Sort a dataset]
     * @returns {wix-data.WixDataSort} A sort object.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'sort',
    value: function sort() {
      return (0, _sortSortBuilder2['default'])();
    }
  }, {
    key: 'find',
    value: function find(collectionName, filter, order, skip, limit, options, includes) {
      return this.provider.find(collectionName, filter, order, skip, limit, options, includes).then(wrapReferences);
    }

    /**
     * @function remove
     * @syntax
     * function remove(collectionName: String, itemId: String,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Removes an item from a collection.
     * @description
     *  The `remove()` function returns a Promise that resolves to the removed item
     *  after the specified item has been deleted from the collection `collectionName`.
     *  The Promise is rejected if the current user does not have delete permissions
     *  for the collection.
     *
     *  Calling the `remove()` function triggers the [`beforeRemove()`](wix-data.Hooks.html#beforeRemove)
     *  and [`afterRemove()`](wix-data.Hooks.html#afterRemove) hooks if they have been defined.
     *
     *  Use the `options` parameter to run `remove()` without checking for permissions
     *  or without its registered hooks.
     * @snippet [WixData-remove.es6=Remove an item from a collection]
     * @snippet [WixData-remove_options.es6=Remove an item from a collection using data options]
     * @param {external:String} collectionName - The collection to remove the item from.
     * @param {external:String} itemId - The ID of the item to remove.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The removed item.
     * @reject {external:Error} The error that caused the rejection.
     *
     * @memberof wix-data
     * @instance
     *
     */
  }, {
    key: 'remove',
    value: function remove(collectionName, itemId, options) {
      var _this3 = this;

      return (0, _sharedValidations.apiValidator)().arity('remove', arguments, 2, 3).collectionName(collectionName).itemId(itemId).options(options).validateAndReject().then(function () {
        return _this3.provider.remove(collectionName, itemId, options);
      }).then(passOrWrap);
    }

    /**
     * @function save
     * @syntax
     * function save(collectionName: String, item: object,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Inserts or updates an item in a collection.
     * @description
     *  The `save()` function returns a Promise that resolves to the inserted or
     *  updated item after the specified item has been added or updated in
     *  the collection `collectionName`. The Promise is rejected with an error if:
     *
     *  + The specified collection does not exist.
     *  + The specified item is not of type `Object`.
     *  + The current user does not have the necessary permissions for the collection.
     *
     *
     *  The `save` function inserts or updates the specified item, depending on
     *  whether it already exists in the collection. It compares the `_id` property
     *  value of the specified item with the `_id` property values of the items in
     *  the specified collection. If an item in the collection has that `_id` value,
     *  `save` uses {@link wix-data#update|update} to update the item in the
     *  collection, triggering the [`beforeUpdate()`](wix-data.Hooks.html#beforeUpdate)
     *  and [`afterUpdate()`](wix-data.Hooks.html#afterUpdate) hooks if they have
     *  been defined. If no items in the collection have that `_id` value, or if the
     *  specified item does not have an `_id` property, `save` uses
     *  {@link wix-data#insert|insert} to add the specified item into the
     *  collection, triggering the [`beforeInsert()`](wix-data.Hooks.html#beforeInsert)
     *  and [`afterInsert()`](wix-data.Hooks.html#afterInsert) hooks if they have
     *  been defined.
     *
     *  Use the `options` parameter to run `save()` without checking for permissions
     *  or without its registered hooks.
     *
     *  When saving an item to a collection that has a reference field, set
     *  the value of the reference field to the referenced item's `_id` value or
     *  the entire referenced item object.
     *
     * @snippet [WixData-save.es6=Save an item in a collection]
     * @snippet [WixData-save_id.es6=Save an item with a specified ID in a collection]
     * @snippet [WixData-save_options.es6=Save an item in a collection using data options]
     * @snippet [WixData-save_ref_id.es6=Save an item including a reference to another item]
     * @snippet [WixData-save_ref_item.es6=Save an item including a reference to another item]
     * @param {external:String} collectionName - The name of the collection to save the item to.
     * @param {external:Object} item - The item to insert or update.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The item that was either inserted or updated, depending on whether it previously existed in the collection.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'save',
    value: function save(collectionName, item, options) {
      var _this4 = this;

      return (0, _sharedValidations.apiValidator)().arity('save', arguments, 2, 3).validateAndReject().then(function () {
        return mutate(_this4.provider, 'save')(collectionName, item, options);
      });
    }

    /**
     * @function update
     * @syntax
     * function update(collectionName: String, item: Object,
     *   [options:WixDataOptions]): Promise&lt;Object&gt;
     * @summary Updates an item in a collection.
     * @description
     *  The `update()` function returns a Promise that resolves to the updated
     *  item from collection `collectionName`. The Promise is rejected if:
     *
     *  + The specified collection does not exist.
     *  + The specified item is not of type `Object`.
     *  + No item in the collection has the specified `_id` value.
     *  + The specified item does not have an `_id` property.
     *  + The current user does not have update permissions for the collection.
     *
     *
     *  Calling the `update()` function triggers the [`beforeUpdate()`](wix-data.Hooks.html#beforeUpdate)
     *  and [`afterUpdate()`](wix-data.Hooks.html#afterUpdate) hooks if they have been defined.
     *
     *  The `update()` function compares the `_id` property of the specified
     *  `item` with the `_id` property values of the items in the specified
     *  collection. If an item in the collection has that `_id` value, `update`
     *  replaced the item's property values with the ones in the specified `item`.
     *  If the existing item had properties with values and those properties were not
     *  included in the supplied `item`, the values in those properties are lost. The
     *  item's `_updatedDate` property is also updated to the current date.
     *
     *  Any valid JavaScript object can be used as a property value. The `update()`
     *  function maintains the structure of the specified object. For example,
     *  objects that contain nested objects, Arrays, or Arrays with nested objects
     *  are all added to the collection as defined.
     *
     *  Use the `options` parameter to run `update()` without checking for permissions
     *  or without its registered hooks.
     *
     *  When updating an item in a collection that has a reference field, set
     *  the value of the reference field to the referenced item's `_id` value or
     *  the entire referenced item object.
     *
     * The maximum size of an item that you can update in a collection is 200kb.
     * @snippet [WixData-update_id.es6=Update an item with a specified ID in a collection]
     * @snippet [WixData-update_options.es6=Update an item in a collection using data options]
     * @snippet [WixData-update_ref_id.es6=Update an item including a reference to another item]
     * @snippet [WixData-update_ref_item.es6=Update an item including a reference to another item]
     * @param {external:String} collectionName - The name of the collection that contains the item to update.
     * @param {external:Object} item - The item to update.
     * @param {wix-data~WixDataOptions} [options] - An object with one or both of the following boolean properties: suppressAuth, suppressHooks.
     * @returns {external:Promise}
     * @fulfill {external:Object} The object that was updated.
     * @reject {external:Error} The error that caused the rejection.
     * @memberof wix-data
     * @instance
     */
  }, {
    key: 'update',
    value: function update(collectionName, item, options) {
      var _this5 = this;

      return (0, _sharedValidations.apiValidator)().arity('update', arguments, 2, 3).validateAndReject().then(function () {
        return mutate(_this5.provider, 'update', true)(collectionName, item, options);
      });
    }
  }, {
    key: 'queryReferenced',
    value: function queryReferenced(collectionName, holdingItem, relationshipAttribute, options) {
      var _this6 = this;

      return (0, _sharedValidations.apiValidator)().arity('queryReferenced', arguments, 3, 4).referenceParameter(holdingItem).validateAndReject().then(function () {
        var itemId = (0, _sharedTypeUtils.isObject)(holdingItem) ? holdingItem._id : holdingItem;

        return _this6.provider.queryReferenced(collectionName, itemId, relationshipAttribute, options).then(function (result) {
          return new _multiref.WixDataQueryReferencedResult(_this6.provider, collectionName, itemId, relationshipAttribute, result, options);
        });
      });
    }
  }, {
    key: 'insertReference',
    value: function insertReference(collectionName, relationshipAttribute, left, right, options) {
      var _this7 = this;

      return (0, _sharedValidations.apiValidator)().arity('insertReference', arguments, 4, 5).referenceParameter(left).referenceParameter(right).validateAndReject().then(function () {
        return _this7.provider.insertReference(collectionName, relationshipAttribute, (0, _sharedTypeUtils.isObject)(left) ? left._id : left, (0, _sharedTypeUtils.isObject)(right) ? right._id : right, options);
      });
    }
  }, {
    key: 'removeReference',
    value: function removeReference(collectionName, relationshipAttribute, left, right, options) {
      var _this8 = this;

      return (0, _sharedValidations.apiValidator)().arity('removeReference', arguments, 4, 5).referenceParameter(left).referenceParameter(right).validateAndReject().then(function () {
        return _this8.provider.removeReference(collectionName, relationshipAttribute, (0, _sharedTypeUtils.isObject)(left) ? left._id : left, (0, _sharedTypeUtils.isObject)(right) ? right._id : right, options);
      });
    }
  }, {
    key: 'isReferenced',
    value: function isReferenced(collectionName, relationshipAttribute, left, right, options) {
      var _this9 = this;

      return (0, _sharedValidations.apiValidator)().arity('isReferenced', arguments, 4, 5).referenceParameter(left).referenceParameter(right).validateAndReject().then(function () {
        return _this9.provider.isReferenced(collectionName, relationshipAttribute, (0, _sharedTypeUtils.isObject)(left) ? left._id : left, (0, _sharedTypeUtils.isObject)(right) ? right._id : right, options);
      });
    }
  }, {
    key: 'bulkInsert',
    value: function bulkInsert(collectionName, items, options) {
      var _this10 = this;

      return (0, _sharedValidations.apiValidator)().arity('bulkInsert', arguments, 2, 3).validateAndReject().then(function () {
        return _this10.provider.bulkInsert(collectionName, items, options);
      }).then(function (bulkResult) {
        var errors = bulkResult.errors.map(function (err) {
          return new _errors.BulkError(err.message, err.code, err.item);
        });
        return Object.assign({}, bulkResult, { errors: errors });
      });
    }
  }, {
    key: 'getSchema',
    value: function getSchema() {
      return this.provider.getSchema();
    }
  }]);

  return WixDataApi;
})();

exports['default'] = WixDataApi;

function wrapReferences(result) {
  var totalCount = result.totalCount;
  if (result.hasOwnProperty('schema') && result.hasOwnProperty('items')) {
    var items = (0, _postprocessingRefDeduplicator.wrapAndDeduplicate)(result.items, result.schema, result.references);
    return { totalCount: totalCount, items: items };
  } else {
    var items = result.items;
    return { totalCount: totalCount, items: items };
  }
}

function mutate(wixData, functionName) {
  var requireId = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

  return function (collectionName, item, options) {
    return (0, _sharedValidations.apiValidator)().collectionName(collectionName).item(item, collectionName, requireId).options(options).validateAndReject().then(function () {
      return wixData[functionName](collectionName, item, options);
    }).then(passOrWrap).then(updateOriginalItem(item));
  };
}

function passOrWrap(item) {
  if (item && item.hasOwnProperty('schema') && item.hasOwnProperty('item')) {
    return (0, _postprocessingRefTransformer.wrapAllReferences)(item.schema, item.item);
  } else {
    return item;
  }
}

function updateOriginalItem(originalItem) {
  return function onItemResponse(item) {
    if (item) {
      for (var prop in item) {
        if (item.hasOwnProperty(prop)) {
          if (!originalItem.hasOwnProperty(prop) || Object.getOwnPropertyDescriptor(originalItem, prop).writable === true) {
            originalItem[prop] = item[prop];
          }
        }
      }

      for (var prop in originalItem) {
        if (!item.hasOwnProperty(prop)) {
          delete originalItem[prop];
        }
      }

      return originalItem;
    } else {
      return undefined;
    }
  };
}

function reflessJoinsEnabled() {
  return true;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/data-api.js
// module id = 165
// module chunks = 0